import { useContext } from 'react';

import { MessagingContext } from '@sorare/wallet-shared';
import type { GeneratedKey } from '@sorare/wallet-shared';

import type { Data } from '#src/components/Form/index.tsx';
import Form from '#src/components/Form/index.tsx';
import useCreateWallet from '#src/hooks/useCreateWallet.ts';
import useHasher from '#src/hooks/useHasher.ts';
import useInfo from '#src/hooks/useInfo.ts';
import { validate } from '#src/lib/password.ts';

import type { Props } from './types.ts';

const fields = [['password', 'password']] as const;

type Field = (typeof fields)[number][0];

const GenerateKey = ({ onSuccess }: Props) => {
  const { user, dict } = useInfo();
  const createWallet = useCreateWallet();

  const hasher = useHasher();
  const { sendRequest } = useContext(MessagingContext)!;

  if (!user) return null;

  const { email, nickname } = user;

  const onSubmit = async ({ password }: Data<Field>) => {
    const passwordError = await validate(email, nickname, password);
    if (passwordError) return { password: passwordError };

    const passwordHash = await hasher(password, email);
    const wallet = await createWallet(password, email);

    const { error } = await sendRequest<GeneratedKey>('generatedKey', {
      passwordHash,
      wallet,
    });

    if (error) return error;
    return {};
  };

  return (
    <Form
      inputs={fields}
      onSubmit={onSubmit}
      onSuccess={onSuccess}
      title={dict.generateWallet}
    />
  );
};

export default GenerateKey;
